/**
 * Used to identify parts of UI for tracking purposes via segment)
 */
export const uiContextIds = {
  // Non-referral
  AddCalendarModal: "AddCalendarModal", //       // `/account/saved-classes` -> more -> subscribe to calendar (modal)
  GiftCardsAdminPage: "GiftCardsAdminPage", //   // `/admin/users/:uid/giftcards`

  // Referral related
  ClassPage: "ClassPage", //                     // `/classes/${uid}/ + click share (opens ActivityShareDialogContent modal)
  ClassPagePostEnroll: "ClassPagePostEnroll", // // `/classes/${uid}/ + complete enrollment + click share in ShareContainer modal
  EnrolledClassPage: "EnrolledClassPage", //     // `/classes/${uid} + <Share class /> button
  GiftInvitationsModal: "GiftInvitationsModal",
  InvitePage: "InvitePage", //                // `/invite` + click <Copy /> button
  LeaderShareMenu: "LeaderShareMenu", //         // `/teachers/${uid}` + click <Share/> button
  ParentProfilePage: "ParentProfilePage",
  ReferTeachersPage: "ReferTeachersPage", //     // `/refer-teachers` + click copy button
  SectionEditPage: "SectionEditPage", //         // `/section/${uid}/edit
  SavedClassesPage: "SavedClassesPage", //       // `/account/saved-classes` (mobile-only) + Share button

  // Default
  NotAssigned: "NotAssigned",
};

export function getExtraMetaData(inputValue: string) {
  if (inputValue) {
    try {
      const url = new URL(inputValue);

      return {
        // TODO: consider that checking inputValue for usid substring is hacky
        // Ideally need to know the redirectUri query param
        isReferral: url.searchParams.has("usid") || inputValue.includes("usid"),
      };
    } catch (e) {} // No need to report errors of invalid URL
  }

  return {
    isReferral: false,
  };
}
